export default __webpack_public_path__ + "images/803f626c78290ce7e45c70154a9d807e-weightlifting.webp";